import { render, staticRenderFns } from "./des-input.vue?vue&type=template&id=a095c760&"
import script from "./des-input.vue?vue&type=script&lang=js&"
export * from "./des-input.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports